import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name:'Service360FilterPipe',
})
export class Service360FilterPipe implements PipeTransform{
    transform(info, filterBillToName,filterShipToName,filterLicenseKey){
        if(info.length===0 || (filterBillToName=='' && filterShipToName=='' && filterLicenseKey=='')){
            return info;
        }
        else{
            return info.filter((item)=>{
                    if(filterBillToName!='' && filterShipToName!='' && filterLicenseKey!=''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && item.ShipToName.toLowerCase()===filterShipToName.toLowerCase() && item.LicenseKey.toLowerCase()===filterLicenseKey.toLowerCase())
                    }
                    else if(filterBillToName=='' && filterShipToName!='' && filterLicenseKey!=''){
                        return (item.ShipToName.toLowerCase()===filterShipToName.toLowerCase() && item.LicenseKey.toLowerCase()===filterLicenseKey.toLowerCase())
                    }
                    else if(filterBillToName!='' && filterShipToName=='' && filterLicenseKey!=''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && item.LicenseKey.toLowerCase()===filterLicenseKey.toLowerCase())
                    }
                    else if(filterBillToName!='' && filterShipToName!='' && filterLicenseKey==''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && item.ShipToName.toLowerCase()===filterShipToName.toLowerCase())
                    }
                    else if(filterBillToName=='' && filterShipToName=='' && filterLicenseKey!=''){
                        return (item.LicenseKey.toLowerCase()===filterLicenseKey.toLowerCase())
                    }
                    else if(filterBillToName!='' && filterShipToName=='' && filterLicenseKey==''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase())
                    }
                    else if(filterBillToName=='' && filterShipToName!='' && filterLicenseKey==''){
                        return (item.ShipToName.toLowerCase()===filterShipToName.toLowerCase())
                    }
                })
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/service360/pipes/service360FilterPipe.ts